import { openModal } from './modal';

export const openMessengerForm = (source) => {
    history.replaceState(
        {},
        '',
        `${window.location.pathname}?source=${source}`
    );

    openModal('.modal', null, source);
};